import { WholesaleOrderDTO } from "@deliverr/wholesale-client";
import { DistributionChannel, OrderResponse } from "@deliverr/replenishment-client";

export const prepWholesaleDetailsMapper = (wholesaleDetails: WholesaleOrderDTO): OrderResponse => {
  return {
    orderStatus: wholesaleDetails.status as OrderResponse["orderStatus"],
    orderId: wholesaleDetails?.id,
    externalId: wholesaleDetails?.externalId,
    createdAt: new Date(wholesaleDetails?.createdAt),
    updatedAt: new Date(wholesaleDetails?.updatedAt),
    sellerId: wholesaleDetails.sellerId,
    distributionChannel: DistributionChannel.WHOLESALE,
  };
};
